import { render, staticRenderFns } from "./MultiSelectBox.vue?vue&type=template&id=6c5a73ca&"
import script from "./MultiSelectBox.vue?vue&type=script&lang=js&"
export * from "./MultiSelectBox.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelectBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports